import type { Habit } from '../interfaces'

export const ALL_HABITS_CATEGORY = 'All'
export const DEFAULT_HABIT_CATEGORY = 'General'

export const HABIT_CATEGORIES = [
  'Health',
  'Learning',
  'Work',
  'Personal',
  DEFAULT_HABIT_CATEGORY,
] as const

export function normalizeHabitCategory(
  category: string | null | undefined,
): string {
  const trimmed = category?.trim()
  return trimmed || DEFAULT_HABIT_CATEGORY
}

export function getCategoryFilterOptions(
  habits: Pick<Habit, 'category'>[],
): string[] {
  const habitCategories = new Set(
    habits.map((habit) => normalizeHabitCategory(habit.category)),
  )

  const activeBuiltIn = HABIT_CATEGORIES.filter((category) =>
    habitCategories.has(category),
  )
  const activeCustom = Array.from(habitCategories).filter(
    (category) =>
      !HABIT_CATEGORIES.includes(category as (typeof HABIT_CATEGORIES)[number]),
  )

  return [ALL_HABITS_CATEGORY, ...activeBuiltIn, ...activeCustom]
}
